
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface UserSubscription {
  id: string;
  user_id: string;
  status: 'active' | 'cancelled' | 'none';
  subscription_type: string;
  stripe_customer_id?: string;
  stripe_subscription_id?: string;
  created_at: string;
  updated_at: string;
}

export const useSubscriptionStatus = () => {
  const [subscription, setSubscription] = useState<UserSubscription | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchSubscriptionStatus = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) return;

      const { data, error } = await supabase
        .from('user_subscriptions')
        .select('*')
        .eq('user_id', session.user.id)
        .eq('status', 'active')
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) throw error;
      setSubscription(data);
    } catch (error) {
      console.error('Error fetching subscription status:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionStatus();
  }, []);

  return {
    subscription,
    isLoading,
    hasActiveSubscription: subscription?.status === 'active',
    subscriptionType: subscription?.subscription_type,
    refreshSubscriptionStatus: fetchSubscriptionStatus,
  };
};
